import request from '@/plugins/request'

export const infoPage = (data) => {
  return request({
    url: '/subject/page',
    method: 'get',
    params: data
  })
}

export const update = (data) => {
  return request({
    url: '/subject/save',
    method: 'post',
    data: data
  })
}

export const getInfo = (id) => {
  return request({
    url: `/subject/${id}`,
    method: 'get'
  })
}

export const remove = (data) => {
  return request({
    url: '/subject/remove',
    method: 'post',
    data: data
  })
}